import React from 'react'
import { FaExclamationCircle } from 'react-icons/fa'

const colorMap = {
    red:   { bg: "bg-brand/15",    border: "border-brand/30",    icon: "text-brand"  },
    amber: { bg: "bg-amber-500/15",    border: "border-amber-500/30",    icon: "text-amber-400"  },
    green: { bg: "bg-green-500/15",    border: "border-green-500/30",    icon: "text-green-400"  },
}

export default function MessageError({
    icon: Icon = FaExclamationCircle,
    iconColor = "red",
    title,
    description,
    action,
}) {
    const colors = colorMap[iconColor] ?? colorMap.red

    return (
        <div role="alert" aria-live="assertive" className="min-h-[70vh] flex items-center justify-center px-4">
            <div className="text-center max-w-sm w-full">
                <div className={`w-20 h-20 rounded-full ${colors.bg} border ${colors.border} flex items-center justify-center mx-auto mb-6`}>
                    <Icon className={`${colors.icon} text-3xl`} />
                </div>
                {title && (
                    <h2 className="font-display text-2xl md:text-3xl font-bold text-white mb-3">{title}</h2>
                )}
                {description && (
                    <p className="text-gray-400 text-sm leading-relaxed mb-6">{description}</p>
                )}
                {action}
            </div>
        </div>
    )
}
